import _ from 'lodash';

/**
 * hasPublicView determines whether a route should have a public header
 * Modify `includes` and `matches` to add new URLs that should have the a publicView header
 * @param {Boolean} hasAuth
 * @param {String} pathname
 * @returns
 */
export const hasPublicView = ({ hasAuth = false, pathname = '/' }) => {
    let ret = false;
    if (hasAuth) {
        return ret;
    }
    const includes = ['/sign-up'];
    const matches = ['/draganddrop'];
    _.forEach(includes, (i) => {
        if (_.includes(pathname, i)) {
            ret = true;
        }
    });
    _.forEach(matches, (m) => {
        if (pathname === m) {
            ret = true;
        }
    });
    return ret;
};
